"use strict";
import React from "react";
export default function Blocker(props) {
  const backdrop = (parent) => {
    return React.createElement(elementType(parent), {
      key: "blocker-backdrop",
      className: "cg-busy cg-busy-backdrop cg-busy-backdrop-animation"
    });
  };
  const view = (parent, modalView) => {
    return React.createElement(
      elementType(parent),
      {
        key: "blocker-view",
        className: "cg-busy cg-busy-animation"
      },
      React.createElement(
        elementType(elementType(parent)),
        {
          className: "cg-busy-default-wrapper",
          style: {
            position: "absolute",
            top: "0px",
            left: "0px",
            right: "0px",
            bottom: "0px"
          }
        },
        React.createElement(
          elementType(elementType(elementType(parent))),
          {
            className: "cg-busy-default-container"
          },
          modalView
        )
      )
    );
  };
  const elementType = (parent) => {
    var type = parent.type || parent;
    if (type === "table") {
      return "tbody";
    } else if (type === "tbody") {
      return "tr";
    } else if (type === "tr") {
      return "td";
    } else {
      return "div";
    }
  };
  var child;
  if (props.modalView) {
    var children;
    child = React.Children.only(props.children);
    if (React.Children.count(child.props.children) === 0) {
      children = [];
    } else if (React.Children.count(child.props.children) === 1) {
      children = [child.props.children];
    } else {
      children = [...child.props.children];
    }
    children.push(backdrop(child));
    children.push(view(child, props.modalView));
    child = React.cloneElement(child, {}, children);
  } else {
    child = props.children;
  }
  return child;
}
